@if(rules?.length){
<div class="bg-col-51 col-1 p-b-3">
    @for (rule of rules; track rule) {
    <p class="p-t-3 center"
       sizeClass="XL:p1, SM:p2">
        {{ rule.isFullfilled ? ('You have Free %' | translate : rule.name) : ('You are % away from Free %' | translate :
        toPriceString(rule.neededValue) : rule.name) }}
    </p>
    }
</div>
}
